import { Stack, Typography } from "@mui/material";
import React from "react";

export interface FAQItem {
  id: string;
  question: string;
  answer: React.ReactNode | string;
}

export const faqData: FAQItem[] = [
  {
    id: "how-it-works",
    question: "How does it work?",
    answer: (
      <Stack gap={1}>
        <Typography variant="body1">
          Just give us access to your app, and we handle everything else. No
          code access, no onboarding, and zero developer time needed.
        </Typography>
        <Typography variant="body1">
          Our system autonomously explores every feature of your service,
          running thorough tests on a schedule — then delivers clear, actionable
          reports right to your inbox. All without pulling your team away from
          building.
        </Typography>
      </Stack>
    ),
  },
  {
    id: "what-types-of-apps",
    question: "What types of apps do you test?",
    answer:
      "Websites, mobile apps (iOS and Android), desktop apps (Mac and Windows), and Chrome browser extensions are all in scope. For everything else: feel free to ask! Chances are that if it’s an app your users interact with, we can test it.",
  },
  {
    id: "quick-results",
    question: "How quickly will I get my first report?",
    answer:
      "Once you share your app access, we’ll deliver your first comprehensive bug report within a few days — in all cases under a week. After that, you can decide to sign up and receive weekly updates, to keep ahead of any issues.",
  },
  {
    id: "developers",
    question: "Do I need to provide test scripts or write any code?",
    answer:
      "Nope! Our team creates and maintains the entire test suite for you. You just give us access, and we take care of business: discover features, write tests, run the testing suite, then report bugs.",
  },
  {
    id: "right-fit",
    question: "Can I customize what gets tested?",
    answer: (
      <Stack gap={1}>
        <Typography variant="body1">
          Yes! While we start with full feature discovery to cover everything,
          you can tell us to focus on specific areas or workflows. This way,
          your tests align perfectly with your priorities and release plans.
        </Typography>
        <Typography variant="body1">
          In fact, feel free to pop those in your &apos;Description&apos; field
          when you sign up!
        </Typography>
      </Stack>
    ),
  },
];
